































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Headerhome from '@/components/headerhome.vue';
import ajax from '@/lib/ajax';
import FlightOrderGeneral from '@/store/entities/flight/flightOrderGeneral';
import Flight from '@/store/entities/flight/flight';
import Passenger from '@/store/entities/order/passenger';
@Component({
  components: { Headerhome },
})
export default class FlightPayment extends Vue {
  birthday: Date = null;
  radios: boolean = true;
  radios1: boolean = true;
  radios2: boolean = true;
  radios3: boolean = true;
  customerGsm:string;
  customerEmail:string;
  flightOrderGeneral: FlightOrderGeneral = new FlightOrderGeneral();
  flight: Flight = new Flight();
  passenger: Passenger = new Passenger();
  showWegoPixel: boolean = false;
  wegoPixelUrl: string = '';
  marker: string = '';
  clickId: string = '';
  async created() {
    // URL'den marker ve click_id değerlerini al
    this.parseUrlParams();
    
    const payload = {
      orderId: this.$route.params.orderId,
    };
    const response = await ajax.post(
      'api/services/app/Booking/GetOrderById',
      payload
    );

    this.flightOrderGeneral = response.data.result;
    this.customerGsm = this.flightOrderGeneral.customer.gsm;
    this.customerEmail = this.flightOrderGeneral.customer.email;
    
    // Wego pixel için gerekli kontrolleri yap ve URL'i oluştur
    this.setupWegoPixel();
  }

  parseUrlParams() {
    // URL'den marker ve diğer parametreleri al
    const urlParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    
    // Önce URL parametrelerinden kontrol et
    this.marker = urlParams.get('marker') || '';
    this.clickId = urlParams.get('click_id') || '';
    
    // Eğer URL parametrelerinde yoksa hash'ten kontrol et
    if (!this.marker || this.marker.length === 0) {
      // Hash içindeki parametreleri parse et
      const hashParts = window.location.hash.split('?');
      if (hashParts.length > 1) {
        const hashUrlParams = new URLSearchParams(hashParts[1]);
        this.marker = hashUrlParams.get('marker') || '';
        this.clickId = hashUrlParams.get('click_id') || '';
      }
    }
    
    console.log('Marker:', this.marker);
    console.log('Click ID:', this.clickId);
  }
  
  setupWegoPixel() {
    // Marker değeri 7 karakterden uzunsa Wego pixel'i göster
    if (this.marker && this.marker.length > 7 && this.flightOrderGeneral) {
      // Sipariş bilgilerini al
      const totalAmount = this.flightOrderGeneral.totalPrice || 0;
      const currency = this.flightOrderGeneral.currencyId || 'TRY';
      const transactionId = this.flightOrderGeneral.orderNo || '';
      const status = 'confirmed'; // Varsayılan olarak onaylandı kabul ediyoruz
      
      // Wego pixel URL'ini oluştur
      this.wegoPixelUrl = `https://srv.wego.com/analytics/v2/conversions?conversion_id=c-wego-charterscanners.com&click_id=${this.clickId || this.marker}&comm_currency_code=${currency}&bv_currency_code=${currency}&transaction_id=${transactionId}&commission=${totalAmount * 0.025}&total_booking_value=${totalAmount}&status=${status}`;
      
      this.showWegoPixel = true;
      console.log('Wego Pixel URL:', this.wegoPixelUrl);
    }
  }

  get pnrNumber() {
    return this.flightOrderGeneral.flightOrders && this.flightOrderGeneral.flightOrders.length > 0
      ? this.flightOrderGeneral.orderNo
      : '';
  }

  get flightDuration() {
    return this.flightOrderGeneral.flightOrders && this.flightOrderGeneral.flightOrders.length > 0
      ? this.flightOrderGeneral.flightOrders[0].flight.flightDuration
      : '';
  }
  get flightOw() {
    return this.flightOrderGeneral.flightOrders && this.flightOrderGeneral.flightOrders.length > 0
      ? this.flightOrderGeneral.flightOrders[0].flight
      : this.flight;
  }
  get flightRt() {
    return this.flightOrderGeneral.flightOrders && this.flightOrderGeneral.flightOrders.length > 1
      ? this.flightOrderGeneral.flightOrders[1].flight
      : this.flight;
  }
  get isFlightRt() {
    return this.flightOrderGeneral.flightOrders && this.flightOrderGeneral.flightOrders.length > 1 ? true : false;
  }

  get passengers() {
    return this.flightOrderGeneral.flightOrders && this.flightOrderGeneral.flightOrders.length > 0 && this.flightOrderGeneral.flightOrders[0].passengers && this.flightOrderGeneral.flightOrders[0].passengers.length > 0
      ? this.flightOrderGeneral.flightOrders[0].passengers[0].passengers
      : this.passenger;
  }
}
